// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_1d5FQzO2hDKtwTRjEWRWy2","tooltiptext":"_3eHoOMahYl_M5RmkHO6J9f"};